<div *ngIf="content_initialized" class="flex-display" aria-label="NoticetoconstituentsPage">
  <div class="float-L width-86" tabindex="0">
    <div class="pr-96px pr-1-25">
      <div class="pcform pr-1-25 print-all-content">
        <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont content-display">{{rfd_header}}</h1>
        <p class="answer font-16 content-blue width-100 pt-10" [innerHTML]="rfd_body"></p>  
      </div>
    </div>
  </div>
</div>
